<template>
  <div class="help-popup">
    <div class="help-popup-header d-flex align-items-center">
      <strong class="mr-auto">Help</strong>
      <button v-if="userIsAdmin && !editing" class="help-header-btn" @click="startEdit" title="Edit help content">
        <font-awesome-icon icon="pencil-alt" />
      </button>
    </div>

    <div class="help-popup-body p-4">
      <div v-if="entry === undefined" class="text-muted">Loading...</div>

      <div v-else-if="visibleEntry === null && !editing" class="text-muted">No help available for this page.</div>

      <div v-else>
        <div v-if="!editing">
          <div v-if="userIsAdmin && !entry.published" class="draft-badge">Draft</div>
          <h3>{{ entry.title }}</h3>
          <div v-html="renderedBody" class="help-body"></div>
        </div>

        <div v-if="editing">
          <b-form-input v-model="editTitle" class="mb-2" placeholder="Title" />
          <b-form-textarea v-model="editBody" rows="15" class="mb-2" placeholder="Write help content in Markdown..." />
          <b-form-checkbox v-model="editPublished" class="mb-2">Published</b-form-checkbox>
          <b-button variant="primary" size="sm" @click="save">Save</b-button>
          <b-button variant="secondary" size="sm" class="ml-2" @click="cancelEdit">Cancel</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {markdownToHtml} from '@/utils/markdownToHtml';

export default {
  name: 'HelpPopupPage',
  data() {
    return {
      editing: false,
      editTitle: '',
      editBody: '',
      editPublished: false
    };
  },
  computed: {
    entry() { return this.$store.getters['help/getByKey'](this.$route.params.key); },
    renderedBody() { return this.entry ? markdownToHtml(this.entry.bodyMd) : ''; },
    userIsAdmin() {
      var roles = this.$store.state.user.roles;
      if (!roles) return false;
      var list = Array.isArray(roles) ? roles : String(roles).split(',');
      return list.some(function (r) {
        return r.trim() === 'admin';
      });
    },
    visibleEntry() {
      if (this.entry === undefined || this.entry === null) return this.entry;
      if (!this.entry.published && !this.userIsAdmin) return null;
      return this.entry;
    }
  },
  created() {
    this.$store.dispatch('help/fetchByKey', this.$route.params.key);
  },
  methods: {
    startEdit() {
      this.editTitle = (this.entry && this.entry.title) ? this.entry.title : '';
      this.editBody = (this.entry && this.entry.bodyMd) ? this.entry.bodyMd : '';
      this.editPublished = !!(this.entry && this.entry.published);
      this.editing = true;
    },
    cancelEdit() { this.editing = false; },
    async save() {
      try {
        var base = this.entry ? Object.assign({}, this.entry) : { scope: 'page' };
        await this.$store.dispatch('help/saveHelp', {
          key: this.$route.params.key,
          content: Object.assign(base, {title: this.editTitle, bodyMd: this.editBody, published: this.editPublished})
        });
        this.editing = false;
      } catch (e) {
        this.$toasted.error('Failed to save help content.');
      }
    }
  }
}
</script>

<style scoped>
.help-popup {
  min-height: 100vh;
  background: white;
}
.help-popup-header {
  padding: 0.6rem 1rem;
  border-bottom: 1px solid #dee2e6;
  background: #f8f9fa;
}
.help-popup-header strong {
  font-size: 1.2em;
}
.help-header-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #6c757d;
  padding: 4px 8px;
  font-size: 1.032rem;
}
.help-header-btn:hover {
  color: #343a40;
}

.draft-badge {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  color: #856404;
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 3px;
  padding: 1px 6px;
  margin-bottom: 6px;
}
</style>
